"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mathPlugin = mathPlugin;
exports["default"] = void 0;

var _inline = _interopRequireDefault(require("./inline.js"));

var _block = _interopRequireDefault(require("./block.js"));

function mathPlugin() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _block["default"].call(this, opts);

  _inline["default"].call(this, opts);
}

var _default = mathPlugin;
exports["default"] = _default;